/* eslint-disable eqeqeq */
import React, { useContext, useState, useEffect } from 'react'
import { IonRow, IonCol, IonLabel, IonInput, IonButton, IonItem, IonSelectOption, IonSelect } from '@ionic/react'
import db from '../../resources/db';
import { toastController } from '@ionic/core';
import { ConfigContext } from '../../contexts/ConfigContext';
import { useRouter } from '../../resources/Hooks';

const UpdateStock = (props) => {

    const { setShowModel, PItem, id } = props.data;
    const [Item, setItem] = useState({})
    const router = useRouter();

    useEffect(() => {
        if (PItem) {
            setItem({ ...PItem })
            console.log('ssfdsg');


        } else {
            db.stocks.get({ productId: id }).then(res => {
                console.log(res);
                setItem(res)
            })

        }
    }, [PItem, id])


    /**Update stock quantity and rate By id */
    const updateStocks = (e) => {
        e.preventDefault()
        const data = {
            quantity: Item.quantity,
            rate: Item.rate, //sale rate
            productName: Item.productName,
            purchaseRate: Item.purchaseRate,
            gstRate: Item.gstRate,
            hsn: Item.hsn
        }
        console.log(data);

        db.stocks.update(parseInt(Item.productId), data).then((res) => {
            if (res) {
                console.log('Product updated');
                toastController.create({
                    color: 'success',
                    duration: 2000,
                    message: `Product '${Item.productId}' updated successfully`,
                    showCloseButton: true
                }).then(toast => {
                    toast.present();
                });

            } else {
                // alert('Product id not exist.');
                toastController.create({
                    color: 'danger',
                    duration: 2000,
                    message: 'Not Updated',
                    showCloseButton: true
                }).then(toast => {
                    toast.present();
                });
            }

        })
        router.replace(`/stocks/`);
    }


    return (
        <div>
            <h5 className='ion-text-center'>Update Stocks</h5>
            {/* /**Stocks Update Form UI */}
            <form onSubmit={updateStocks} >
                <IonRow>
                    <IonCol>
                        <IonItem>
                            <IonLabel position='floating'>Product Name</IonLabel>
                            <IonInput type="text" required id='pname' value={Item.productName} onIonInput={e => { setItem({ ...Item, productName: ((e.target.value).trim()) }) }} />
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>HSN/SAC Code</IonLabel>
                            <IonInput type="text" id='hsn' value={Item.hsn} onIonInput={e => { setItem({ ...Item, hsn: ((e.target.value).trim()) }) }} />
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>GST Rate</IonLabel>
                            <IonSelect interface='popover' id='gstr' selectedText={Item.gstRate} onIonChange={e => {
                                setItem({ ...Item, gstRate: (e.target.value) }); console.log(e.target.value);
                            }}>
                                <IonSelectOption selected={0 == Item.gstRate} value="0">Tax Free</IonSelectOption>
                                <IonSelectOption selected={0.25 == Item.gstRate} value="0.25">0.25%</IonSelectOption>
                                <IonSelectOption selected={3 == Item.gstRate} value="3">3%</IonSelectOption>
                                <IonSelectOption selected={5 == Item.gstRate} value="5">5%</IonSelectOption>
                                <IonSelectOption selected={12 == Item.gstRate} value="12">12%</IonSelectOption>
                                <IonSelectOption selected={18 == Item.gstRate} value="18">18%</IonSelectOption>
                                <IonSelectOption selected={28 == Item.gstRate} value="28">28%</IonSelectOption>
                            </IonSelect>
                        </IonItem>

                    </IonCol>
                    <IonCol>
                        <IonItem>
                            <IonLabel position='floating'>Quantity</IonLabel>
                            <IonInput type="number" min='0' readonly step='any' value={Item.quantity} required id='u-quantity' onIonInput={e => { setItem({ ...Item, quantity: parseFloat(e.target.value) }) }} />
                        </IonItem>

                        <IonItem>
                            <IonLabel position='floating'>Purchase Rate</IonLabel>
                            <IonInput type="number" min='0' step='any' value={Item.purchaseRate} id='u-rate' onIonInput={e => { setItem({ ...Item, purchaseRate: parseFloat(e.target.value) }) }} />
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>Sale Rate</IonLabel>
                            <IonInput type="number" min='0' step='any' value={Item.rate} id='u-rate' onIonInput={e => { setItem({ ...Item, rate: parseFloat(e.target.value) }) }} />
                        </IonItem>
                        <IonButton color='danger' type='submit' onClick={() => setShowModel(false)}>Update</IonButton>
                    </IonCol>
                </IonRow>
            </form>
        </div>
    )
}

export default UpdateStock
